import { z } from 'zod';
// ─── WebhookSubscription ─────────────────────────────────────────────────────
export const WebhookSubscriptionSchema = z.object({
    id: z.string(),
    orgId: z.string(),
    name: z.string(),
    url: z.string().url(),
    eventTypes: z.array(z.string()),
    workflowIds: z.array(z.string()),
    active: z.boolean(),
    metadata: z.record(z.string(), z.unknown()),
    createdAt: z.date(),
    updatedAt: z.date(),
});
export const CreateWebhookSubscriptionInputSchema = z.object({
    name: z.string().min(1).max(200),
    url: z.string().url().max(2000),
    /** HMAC-SHA256 key. Write-only — never returned in responses. */
    secret: z.string().min(16).max(200),
    eventTypes: z.array(z.string().min(1)).default([]),
    workflowIds: z.array(z.string().min(1)).default([]),
    active: z.boolean().default(true),
    metadata: z.record(z.string(), z.unknown()).default({}),
});
export const UpdateWebhookSubscriptionInputSchema = CreateWebhookSubscriptionInputSchema.partial();
// ─── WebhookDelivery ─────────────────────────────────────────────────────────
export const WebhookDeliveryStatusSchema = z.enum([
    'PENDING',
    'DELIVERED',
    'FAILED',
    'DEAD_LETTERED',
]);
export const WebhookDeliverySchema = z.object({
    id: z.string(),
    orgId: z.string(),
    subscriptionId: z.string(),
    eventType: z.string(),
    payload: z.record(z.string(), z.unknown()),
    signature: z.string(),
    status: WebhookDeliveryStatusSchema,
    attempts: z.number().int().nonnegative(),
    maxAttempts: z.number().int().positive(),
    lastStatusCode: z.number().int().nullable(),
    lastResponse: z.string().nullable(),
    lastError: z.string().nullable(),
    nextAttemptAt: z.date().nullable(),
    deliveredAt: z.date().nullable(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
//# sourceMappingURL=webhook.js.map